import { useEffect, useRef } from 'react';
import { useTour } from '@reactour/tour';
import { useOnboarding } from 'contextProviders/OnboardingProvider';
import { getActiveTourKey, setActiveTourKey } from './activeTour';
import { getTourOutcome, setTourOutcome } from './tourOutcome';

// Mounted under the TourProvider. When a tour closes, logs the explicit outcome
// set by the footer buttons — 'completed' (Finish) or 'skipped' (Skip). If the
// tour was dismissed without a button, falls back to 'skipped'.
const OnboardingTourController = () => {
	const { isOpen } = useTour();
	const { tours, logEvent } = useOnboarding();
	const wasOpenRef = useRef(false);
	// Read the latest checklist inside the close effect without re-running it.
	const toursRef = useRef(tours);
	toursRef.current = tours;

	useEffect(() => {
		if (isOpen) {
			wasOpenRef.current = true;
			return;
		}

		if (wasOpenRef.current) {
			wasOpenRef.current = false;
			const key = getActiveTourKey();
			if (key) {
				const outcome = getTourOutcome() ?? 'skipped';
				const alreadyCompleted = toursRef.current.some(
					(t) => t.tourKey === key && t.status === 'completed',
				);
				// A skip must not overwrite a tour already completed at this
				// version — just end it without logging.
				if (!(outcome === 'skipped' && alreadyCompleted)) {
					logEvent({ tourKey: key, status: outcome });
				}
				setActiveTourKey(null);
				setTourOutcome(null);
			}
		}
	}, [isOpen, logEvent]);

	return null;
};

export default OnboardingTourController;
